import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Form,
  validateForm,
  isFormValid,
} from '@arreeba/arreeba-form';

// utility for merging form single field errors
// and extra errors
const mergeErrors = (errors, extra) => {
  const mergedErrors = { ...errors };
  _.forIn(extra, (val, key) => {
    const err = mergedErrors[key] || [];
    mergedErrors[key] = err.concat(val);
  });
  return mergedErrors;
};

class FormWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: this.props.config,
      errors: {},
    };
    this.save = this.save.bind(this);
  }

  save(data) {
    const config = this.state.config.map((field) => {
      return {
        ...field,
        initialValue: data[field.name] || '',
      };
    }, {});

    const extraErrors = (this.props.extraCheck) ?
      this.props.extraCheck(data) : {};

    const errors = mergeErrors(
      validateForm(data, config),
      extraErrors,
    );
    if (!isFormValid(errors)) {
      this.setState({ errors, config });
      return;
    }
    this.props.onValidSave(data);
  }

  render() {
    return (
      <Form
        data={this.state.config}
        errors={this.state.errors}
        onSubmit={this.save}
        onSave={this.save}
        onCancel={this.props.onCancel}
        submitButtonLabel={this.props.submitButtonLabel}
        cancelButtonLabel={this.props.cancelButtonLabel}
        submitClassNames={['btn-submit']}
      />
    );
  }
}

FormWrapper.propTypes = {
  config: PropTypes.array.isRequired,
  extraCheck: PropTypes.func,
  onValidSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  submitButtonLabel: PropTypes.string,
  cancelButtonLabel: PropTypes.string,
};

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/components/form-wrapper.js